import { Head } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media, Button } from "../components/Object";
import { useState, useMemo, useCallback, useEffect } from "react";
import { useDocumentLoadCompleted } from "../components/Hooks";

const Contact = () => {
  const isLoaded = useDocumentLoadCompleted();
  const [formId, setFormId] = useState();
  const [message, setMessage] = useState();
  const [status, setStatus] = useState("validation_failed");

  useEffect(() => {
    fetch(`${tmp_path.site_url}/wp-json/wp/v2/pages?slug=contact`)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data[0].acf.id);
        setFormId(data[0].acf.id);
      });
  }, [isLoaded]);

  // const formId = 5;

  // const [status, setStatus] = useState("mail_sent");

  const handleSubmit = async (event) => {
    const API_URL = `${tmp_path.site_url}/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback`;
    console.log(formId);
    event.preventDefault();
    const formElement = event.target;
    const body = new FormData(formElement);
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LdmC4smAAAAAMVFa9NMzgNCiJmtlTE7Ohn6COrf", {
          action: "submit",
        })
        .then(function (token) {
          body.set('_wpcf7_recaptcha_response', token);
          fetch(API_URL, {
            method: "POST",
            body,
          })
            .then((res) => res.json())
            .then((res) => {
              setMessage(res.message);
              if (res.status === "mail_sent") {
                setStatus(res.status);
              }
              if (res.invalid_fields) {
              }
              scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
            })
            .catch((error) => {
              console.error("通信に失敗しました", error);
            });
        });
    });
  };

  const DefaultElm = () => {
    return (
      <>
        <form action="/contact/#wpcf7-f77-o3" onSubmit={(e) => handleSubmit(e)}>
          <div className="p-form__wrap">
            <input type="hidden" name="_wpcf7" value={formId} />
            <input
              type="hidden"
              name="_wpcf7_unit_tag"
              value={`wpcf7-f${formId}-o1`}
            />
            <input type="hidden" name="_wpcf7_locale" value="ja" />
            <Input
              name="subject"
              label="お問い合わせ種別"
              elm="radio"
              value={[
                "ご相談・ご質問",
                "ご提案依頼",
                "お見積り依頼",
                "代理店契約について",
                "その他",
              ]}
            />
            <Input name="company" req={true} label="屋号・会社名" elm="text" />
            <Input name="your-name" req={true} label="お名前" elm="text" />
            {/* <Input name="your-furi" req={true} label="ふりがな" elm="text" /> */}
            <Input name="your-address" req={true} label="ご住所" elm="text" />
            <Input name="your-number" req={true} label="電話番号" elm="text" />
            <Input
              name="your-mail"
              req={true}
              label="メールアドレス"
              elm="text"
            />
            <Input
              name="body"
              req={true}
              label="お問い合わせ内容"
              elm="textarea"
            />
            <Input
              name="acceptance-302"
              req={true}
              label="入力をご確認のうえ、チェックをつけてください"
              elm="check"
            />
          </div>
          <div className="u-margin--64">
            <div className="l-row" data-state="min">
              <Space size={["0 auto", "0 auto"]}>
                <button
                  className="c-button p-form__submit"
                  type="black-big"
                  data-state="black-big"
                >
                  <div className="c-button__wrap--text">
                    <Texts
                      class="c-text--white c-text--bold"
                      slug={"button/submit"}
                    />
                    <div
                      className="c-button__img--arrow"
                      data-state="black-big"
                    ></div>
                  </div>
                </button>
              </Space>
            </div>
          </div>
        </form>
      </>
    );
  };

  const BodyElm = () => {
    if (status == "mail_sent") {
      return (
        <>
          <Texts slug="contact/fin" class="c-text--center"></Texts>
          <div className="u-margin--64">
            <Button link="/" slug="returntop" type="center"></Button>
          </div>
        </>
      );
    } else {
      return <DefaultElm />;
    }
  };

  const BodyElmMemo = useMemo(() => <BodyElm />, [status, formId]);

  return (
    <>
      <Head slug="contact" type="noimage"></Head>
      {message && (
        <div className="p-form__message p-form__message--fix">
          <p className="c-text__med c-text--bold">{message}</p>
        </div>
      )}
      <div className="p-post__wrap">
        <div className="l-row">
          <div className="p-post__wrap--inner">{BodyElmMemo}</div>
        </div>
      </div>
      <Space size={["200px", "120px"]}></Space>
    </>
  );
};

export default Contact;

const Input = (props) => {
  const inputElm = {
    text: function text(props) {
      return (
        <input
          className="c-input"
          type="text"
          placeholder=""
          name={props.name}
        />
      );
    },
    check: function text(props) {
      return (
        <input
          className="c-input--check"
          type="checkbox"
          placeholder=""
          name={props.name}
        />
      );
    },
    textarea: function textarea(props) {
      return <textarea className="c-input" name={props.name}></textarea>;
    },
    radio: function radio(props) {
      let name = props.name;
      let Items = props.value.map((item, value) => {
        return (
          <>
            <label className="c-input__radio--wrap">
              <input
                className="c-input c-input__radio"
                name={name}
                type="radio"
                value={item}
              ></input>
              <p className="p-text__bold">{item}</p>
            </label>
          </>
        );
      });
      return (
        <div className="p-grid__column--repeat--2 p-grid__gap--16">{Items}</div>
      );
    },
  };
  return (
    <div className={`p-form__items p-form__items--${props.elm}`}>
      <label className="c-text__bold">{props.label}</label>
      {inputElm[props.elm](props)}
    </div>
  );
};